import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_TRANSFER_KEY,
  UPDATE_TRANSFER_KEY,
  GET_SEAMLESS_KEY,
  UPDATE_SEAMLESS_KEY,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'apikey' })
export default class ApiKey extends VuexModule {
  listTransferKey: any = [];

  listSeamlessKey: any = [];

  @Mutation
  mutateTransferKey(transferKey) {
    this.listTransferKey = transferKey;
  }

  @Action({ commit: 'mutateTransferKey' })
  FetchTransferKey(params = {}) {
    return Vue.axios({
      url: BASE_URL + GET_TRANSFER_KEY,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateTransferKey(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_TRANSFER_KEY,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Mutation
  mutateSeamlessKey(seamlessKey) {
    this.listSeamlessKey = seamlessKey;
  }

  @Action({ commit: 'mutateSeamlessKey' })
  FetchSeamlessKey(params = {}) {
    return Vue.axios({
      url: BASE_URL + GET_SEAMLESS_KEY,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateSeamlessKey(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_SEAMLESS_KEY,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
